import { Box, Flex, List, ListItem, Text } from '@shared/components';

import {
  QCONFIG_PUBLISH_ERROR_MESSAGES,
  QConfigPublishValidationErrorCode,
  publishQConfigErrorsByPage,
} from './constants';
import DisabledLOSList from './disabled-los-list';

interface ErrorValues {
  DISABLED_LEARNING_OBJECTIVE_STATEMENTS_FOUND: {
    disabledLOSList: { id: string; name: string | null }[];
  };
}

interface PublishRequiredListProps {
  errors: string[];
  values?: ErrorValues;
}

export default function PublishRequiredList(props: Readonly<PublishRequiredListProps>) {
  const { errors, values } = props;

  return (
    <Box>
      <Text variant='body2'>กรุณาตรวจสอบและแก้ไขข้อมูลต่อไปนี้ก่อนเผยแพร่:</Text>
      {Object.entries(publishQConfigErrorsByPage).map(([page, pageErrors]) => {
        const hasError = pageErrors.some((error) => errors.includes(error));
        if (!hasError) return null;

        return (
          <Flex
            key={page}
            sx={{
              flexDirection: 'column',
            }}
          >
            <Text variant='body2Semibold'>{page}:</Text>
            <List
              sx={(theme) => ({
                listStyle: 'disc',
                display: 'flex',
                flexDirection: 'column',
                p: theme.spacing(0, 0, 0, 6),
              })}
            >
              {pageErrors.map((error) => {
                if (!errors.includes(error)) return null;

                return (
                  <ListItem
                    key={error}
                    sx={(theme) => ({
                      display: 'list-item',
                      p: theme.spacing(0),
                      ...theme.typography.body2,
                    })}
                  >
                    {QCONFIG_PUBLISH_ERROR_MESSAGES[error]}
                    {error ===
                      QConfigPublishValidationErrorCode.DISABLED_LEARNING_OBJECTIVE_STATEMENTS_FOUND &&
                    values?.DISABLED_LEARNING_OBJECTIVE_STATEMENTS_FOUND ? (
                      <DisabledLOSList
                        losList={
                          values.DISABLED_LEARNING_OBJECTIVE_STATEMENTS_FOUND.disabledLOSList
                        }
                      />
                    ) : null}
                  </ListItem>
                );
              })}
            </List>
          </Flex>
        );
      })}
    </Box>
  );
}
